import { STHead, STCareer } from "@/components";
import { getPageContentBySlug } from "@/actions";
import React from "react";

export async function getStaticProps() {
  let pageData = null;
  try {
    const res = await getPageContentBySlug("career");
    if (res?.success && res?.data) {
      pageData = res.data;
    }
  } catch (error) {
    console.error("Error fetching career page data:", error);
  }

  return {
    props: {
      pageData,
    },
    revalidate: 60,
  };
}

const Career = ({ pageData }) => {
  const pageContent = pageData?.page?.page_content || {};
  const imageUrlBase = pageData?.imageUrl || "https://sustanix.com/";

  const metaTitle = pageContent.meta_title || "Career";
  const metaDescription =
    pageContent.meta_description ||
    "Deeptech inventions takes ages to frutify and we look for committed team members who can help accelerate the technology development because developing sustainable products is what keeps us excited. Join the team, be that change!";
  const metaKeywords =
    pageContent.meta_keywords ||
    "Careers at Sustanix, jobs, green chemistry, sustainable additives";

  const ogTitle = pageContent.og_title || metaTitle || "Join Sustanix's team of curious inventors";
  const ogDescription =
    pageContent.og_description ||
    metaDescription ||
    "Transitioning the world from fossil-based to plant-based technology requires a massive scientific & industrial collaboration. Join the mission, and see how much we can change the world!";
  const ogKeywords =
    pageContent.og_keywords ||
    metaKeywords ||
    "Sustanix careers, jobs, green chemistry, sustainable additives";

  const ogImage = pageContent.og_image
    ? `${imageUrlBase}${pageContent.og_image}`
    : "https://sustanix.com/opengraph-image.webp";

  return (
    <>
      <STHead
        title={metaTitle}
        description={metaDescription}
        keywords={metaKeywords}
        canonicalUrl="https://sustanix.com/career/"
        ogTitle={ogTitle}
        ogDescription={ogDescription}
        ogKeywords={ogKeywords}
        ogUrl="https://sustanix.com/career/"
        ogImage={ogImage}
        ogType="website"
      />
      <STCareer pageData={pageData} />
    </>
  );
};

export default Career;

